import { useState, useEffect } from 'react'

import { getEmailHistory } from '../api'
import { GetEmailHistoryResponse } from '../typings'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetEmailHistoryOnMount = (agreementId: number) => {
  const dispatch = useAppDispatch()

  const [emailData, setEmailData] = useState<{
    status: 'pending' | 'success' | 'fail'
    history?: GetEmailHistoryResponse
  }>(() => ({ status: 'pending' }))

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getEmailHistory(agreementId))

        if (mounted) {
          if (getEmailHistory.fulfilled.match(result)) {
            setEmailData({ history: result.payload, status: 'success' })
          } else {
            setEmailData({ status: 'fail' })
            toast.error('Error loading email history.')
          }
        }
      } catch {
        if (mounted) {
          setEmailData({ status: 'fail' })
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, agreementId])

  return emailData
}
